module.exports = __webpack_public_path__ + "static/media/info-btn-2.af4778eb.jpg";